



























































































































import { defineComponent, PropType, ref } from '@vue/composition-api';
import {
  IWorkflowStateThreshold,
  IWorkflowStateThresholdData,
  IWorkflowStateThresholdGroup,
  IWorkflowStateThresholdGroupData
} from '@/models';
import { getPropertyFromItem } from '@/utils/helpers';
import { useFetchThresholds } from '@/composable/useWorkflowStateThreshold';

import { useDeleteThresholdGroup } from '@/composable/useWorkflowStateThresholdGroup';

import auth from '@/mixins/auth';

import AlTooltipBtn from '../common/AlTooltipBtn.vue';
import WorkflowStateThresholdFormDialog from './WorkflowStateThresholdFormDialog.vue';
import WorkflowStateThresholdDetail from './WorkflowStateThresholdDetail.vue';
import WorkflowStateThresholdGroupFormDialog from './WorkflowStateThresholdGroupFormDialog.vue';
import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';

export default defineComponent({
  name: 'WorkflowStateThresholdsGroupDetail',

  components: {
    AlTooltipBtn,
    DetailOptionsButton,
    DeleteConfirmationDialog,
    WorkflowStateThresholdDetail,
    WorkflowStateThresholdFormDialog,
    WorkflowStateThresholdGroupFormDialog
  },

  props: {
    workflowId: { type: Number, required: true },
    workflowStateId: {
      type: Number,
      required: true
    },
    group: {
      type: Object as PropType<IWorkflowStateThresholdGroup>,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },

  mixins: [auth],

  setup(props, { emit }) {
    const {
      thresholds,
      isLoadingThresholds,
      thresholdsError
    } = useFetchThresholds(props.workflowId, props.workflowStateId);

    const {
      deleteThresholdGroupErrorReset,
      deleteThresholdGroup,
      isDeletingThresholdGroup,
      deleteThresholdGroupError
    } = useDeleteThresholdGroup(props.workflowId, props.workflowStateId);

    const deleteThresholdDialog = ref(false);

    function removeThresholdGroup() {
      deleteThresholdGroupErrorReset();
      deleteThresholdGroup(props.group.id!, {
        onSuccess: () => {
          closeDeleteThresholdDialog();
        }
      });
    }

    function closeDeleteThresholdDialog() {
      deleteThresholdDialog.value = false;
      selectedThreshold.value = null;
    }

    function filteredThresholds(group: IWorkflowStateThresholdGroup) {
      return thresholds.value.filter(
        (t: IWorkflowStateThreshold) =>
          t.threshold_group &&
          getPropertyFromItem(t.threshold_group, 'id', t.threshold_group) ===
            group.id
      );
    }

    const isEdit = ref(false);

    const isDialogActive = ref(false);
    const selectedThreshold = ref<IWorkflowStateThresholdData | null>(null);

    function openStateThresholdDialog(threshold?: IWorkflowStateThresholdData) {
      isDialogActive.value = true;
      selectedThreshold.value = threshold ?? null;
    }

    function openEditThresholdGroupDialog(group: IWorkflowStateThresholdGroup) {
      emit('edit-threshold-group-pressed', group);
    }

    function openAddThresholdToGroupDialog(
      group: IWorkflowStateThresholdGroupData
    ) {
      isEdit.value = false;
      openStateThresholdDialog({
        threshold_group: group.id!
      });
    }

    function openEditStateThresholdDialog(
      threshold: IWorkflowStateThresholdData
    ) {
      isEdit.value = true;
      openStateThresholdDialog(threshold);
    }

    return {
      isDialogActive,
      isEdit,
      selectedThreshold,
      openEditThresholdGroupDialog,
      openAddThresholdToGroupDialog,
      openEditStateThresholdDialog,
      filteredThresholds,
      isLoadingThresholds,
      thresholdsError,

      deleteThresholdDialog,
      closeDeleteThresholdDialog,
      removeThresholdGroup,
      isDeletingThresholdGroup,
      deleteThresholdGroupError
    };
  }
});
